import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Item = styled.div `
  padding: ${theme.spacing.sm} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${theme.semantic.surface.secondary};
  }
`;
